export const FETCH_STATUSES = {
  loading: 'loading',
  error: 'error',
  success: 'success',
};
